<template>
  <div class="ma-2" >
    <v-container fluid>
      <v-row>
        <v-col>
          <v-select :items="filiais" v-model="filial" clearable label="Selecione a empresa" item-text="cc_fil" item-value="cc_fil"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert border="top" type="info" colored-border elevation="2">
            O método utilizado em todas as requisições é POST. O tipo de conteúdo passado nas requisições é application/json. 
            Para todas as requisições é passada no header o atributo de autenticação denominado <b>Basic Autentication</b>, o mesmo é gerado através do usuário e senha informados.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">

          <v-container fluid class="">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
                <pm-recurso ref="refConsultaCliente" :filial="filial" :recurso="recursos.consultaCliente" :key="recursos.consultaCliente.key" v-on:a="recursos.consultaCliente.key = undefined"></pm-recurso>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
                <pm-recurso ref="refCreditoDevolucao" :filial="filial" :recurso="recursos.creditoDevolucao" :key="recursos.creditoDevolucao.key" v-on:a="recursos.creditoDevolucao.key = undefined"></pm-recurso>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
                <pm-recurso ref="refValidaSerial" :filial="filial" :recurso="recursos.validaSerial" :key="recursos.validaSerial.key" v-on:a="recursos.validaSerial.key = undefined"></pm-recurso>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
                <pm-recurso ref="refTrocaFone" :filial="filial" :recurso="recursos.trocaFone" :key="recursos.trocaFone.key" v-on:a="recursos.trocaFone.key = undefined"></pm-recurso>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
                <pm-recurso ref="refSenhaGarantia" :filial="filial" :recurso="recursos.senhaGarantia" :key="recursos.senhaGarantia.key" v-on:a="recursos.senhaGarantia.key = undefined"></pm-recurso>
              </v-col>
            </v-row>
            <v-row>
                <v-col>
                  <v-btn depressed block color="primary" @click="salvar()" :disabled="filial === undefined">
                    salvar
                  </v-btn>
                </v-col>
            </v-row>
          </v-container>

        </v-col>
      </v-row>
    </v-container>

  </div>
</template>
<script>
import RecursoForm from './RecursoForm.vue'

export default {

  name: 'Recurso',

  data () {
    return {

      filiais: [],
      filial: undefined,

      recursos: {
        consultaCliente: {
          nome: 'CONSULTACLIENTE',
          descricao: 'Consulta os dados do cliente',
          key: undefined,
          modeloEnvio: {
            cc_cli_ins_fed: 'string'
          },
          modeloRetorno: {
            valido: 'boolean',
            valor: {
              nm_cli: 'strin',
              tx_cli_end_bai: 'string',
              tx_cli_tel: 'string',
              tx_cli_end_num: 'string',
              tx_cli_end_cmp: 'string',
              tx_cli_end_mun: 'string',
              cc_cli_end_cpt: 'string',
              cc_cli_end_est: 'string',
              cc_cli_ins_fed: 'string',
              tx_cli_end_log: 'string',
              cc_cli_end_cge: 'string',
              em_cli: 'strin'
            } 
          },
        },

        creditoDevolucao: {
          nome: 'CREDDEV',
          descricao: 'Consulta crédito do ciente',
          key: undefined,
          modeloEnvio: {
            cc_org:'string',
            cc_fil:"string",
            cc_ins_fed:'string',
            cc_ped:'string',
            vl_pgt:'numeric',
            cc_vou:'string',
          },
          modeloRetorno: {
            valido: 'boolean',
            valor: {} 
          },
        },

        validaSerial: {
          nome: 'VALIDASERIAL',
          descricao: 'Valida o código de série do produto',
          key: undefined,
          modeloEnvio: {
            cc_org:'string',
            cc_psr:'string',
            cc_sr1:'string',
          },
          modeloRetorno: {
            valido: 'boolean',
            valor: {} 
          },
        },

        trocaFone: {
          nome: 'TROCAFONE',
          descricao: 'Troca fone',
          key: undefined,
          modeloEnvio: {
            cc_org: 'string',
            cc_fil: 'string',
            cc_ins_fed: 'string',
            cc_ped: 'string',
            vl_pgt: 'number',
            cc_vou: 'string'
          },
          modeloRetorno: {
            valido: 'boolean',
            valor: {} 
          },
        },

        senhaGarantia: {
          nome: 'SENHAGARANTIA',
          descricao: 'Senha garantia',
          key: undefined,
          modeloEnvio: {
            cc_org: 'string',
            cc_fil: 'string',
            cc_ins_fed: 'string',
            cc_ped: 'string',
            vl_pgt: 'number',
            cc_vou: 'string'
          },
          modeloRetorno: {
            valido: 'boolean',
            valor: {} 
          },
        },

      }

    }
  },

  components: {
    'pm-recurso': RecursoForm
  },

  mounted () {

  },

  created() {
    this.$vuetify.goTo(0)
    this.populaFiliais()
  },

  watch: {
    filial: {
      handler: function() {
        
        this.resetaModeloConsultaCliente()
        this.resetaModeloCreditoDevolucao()
        this.resetaModeloValidaSerial()
        this.resetaModeloTrocaFone()
        this.resetaModeloSenhaGarantia()

        this.recursos.consultaCliente.key = Math.random()
        this.recursos.creditoDevolucao.key = Math.random()
        this.recursos.validaSerial.key = Math.random()
        this.recursos.trocaFone.key = Math.random()
        this.recursos.senhaGarantia.key = Math.random()
      }
    }
  },

  methods: {

    populaFiliais() {
      this.$store.dispatch('obterFiliais', {}).then(resp => {
        this.filiais = resp.data.content
      }).catch(err => {
        console.log(err)
      })
    },

    salvar() {
      this.$refs.refConsultaCliente.salvar()
      this.$refs.refCreditoDevolucao.salvar()
      this.$refs.refValidaSerial.salvar()
      this.$refs.refTrocaFone.salvar()
      this.$refs.refSenhaGarantia.salvar()
    },

    resetaModeloConsultaCliente() {
      this.recursos.consultaCliente.modeloEnvio.cc_cli_ins_fed = "string"
    },

    resetaModeloCreditoDevolucao() {
      this.recursos.creditoDevolucao.modeloEnvio.cc_org = 'string'
      this.recursos.creditoDevolucao.modeloEnvio.cc_fil = "string"
      this.recursos.creditoDevolucao.modeloEnvio.cc_ins_fed = 'string'
      this.recursos.creditoDevolucao.modeloEnvio.cc_ped = 'string'
      this.recursos.creditoDevolucao.modeloEnvio.vl_pgt = 'numeric'
      this.recursos.creditoDevolucao.modeloEnvio.cc_vou = 'string'
    },

    resetaModeloValidaSerial() {
      this.recursos.validaSerial.modeloEnvio.cc_org = 'string'
      this.recursos.validaSerial.modeloEnvio.cc_psr = "string"
      this.recursos.validaSerial.modeloEnvio.cc_sr1 = 'string'
    },

    resetaModeloTrocaFone() {
      this.recursos.trocaFone.modeloEnvio.cc_org = 'string',
      this.recursos.trocaFone.modeloEnvio.cc_fil = 'string',
      this.recursos.trocaFone.modeloEnvio.cc_ins_fed = 'string',
      this.recursos.trocaFone.modeloEnvio.cc_ped = 'string',
      this.recursos.trocaFone.modeloEnvio.vl_pgt = 'number',
      this.recursos.trocaFone.modeloEnvio.cc_vou = 'string'
    },

    resetaModeloSenhaGarantia() {
      this.recursos.senhaGarantia.modeloEnvio.cc_org = 'string',
      this.recursos.senhaGarantia.modeloEnvio.cc_fil = 'string',
      this.recursos.senhaGarantia.modeloEnvio.cc_ins_fed = 'string',
      this.recursos.senhaGarantia.modeloEnvio.cc_ped = 'string',
      this.recursos.senhaGarantia.modeloEnvio.vl_pgt = 'number',
      this.recursos.senhaGarantia.modeloEnvio.cc_vou = 'string'
    },

    

  },
}
</script>
<style scoped>

  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }

</style>